<template>
  <div class="inner-wrap">

    <label>Distrito:</label>
    <AddressCombobox 
      name="distrito"
      v-model="distrito"
      :options="ubicacionesOptions"
      @change="handleLocationChange"
    />
    
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'Distrito',
  props: {
    
  },
  mounted() {
    this.$store.dispatch('countries/peru/loadUbigeo')
    this.prepareLocationOptions()
  },
  components: {
    AddressCombobox: () => import('./AddressCombobox.vue'),
  },
  data() {
    return {
      ubicacionesOptions: [], // Se llenará con datos procesados
      distrito: null,
    };
  },
  computed: {
    ...mapState('countries/peru', {
      departamentos: state => state.departamentos,
      provincias: state => state.provincias,
      distritos: state => state.distritos,
    }),
  },
  methods: {
    handleLocationChange(selectedOption) {
      this.$emit('update:distrito', selectedOption);
    },
    prepareLocationOptions() {
      console.log("prepareLocationOptions-----")
      console.log(this.departamentos)
      this.ubicacionesOptions = [];
      
      // 1. Procesar departamentos
      this.departamentos.forEach(depto => {
        const deptoName = depto.value;
        
        // 2. Buscar provincias para este departamento
        const provincias = this.provincias[deptoName] || [];
        
        provincias.forEach(prov => {
          const provName = prov.value;
          
          // 3. Buscar distritos para esta provincia
          const distritos = this.distritos[provName] || [];
          
          distritos.forEach(dist => {
            this.ubicacionesOptions.push(
              `${deptoName} > ${provName} > ${dist.value}`
            );
          });
        });
      });

      // console.log("Opciones generadas:", JSON.parse(JSON.stringify(this.ubicacionesOptions)));
    },
  }
}
</script>